import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=70966762&scoped=true&"
import script from "./entry.vue?vue&type=script&lang=js&"
export * from "./entry.vue?vue&type=script&lang=js&"
import style0 from "./entry.vue?vue&type=style&index=0&id=70966762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70966762",
  null
  
)

export default component.exports